import { useState } from 'react'
import { useAuth } from '../state/auth'
import { getBranding } from '../state/branding'
import { ProjectsTab } from './tabs/ProjectsTab'
import { GarmentsTab } from './tabs/GarmentsTab'
import { BookTab } from './tabs/BookTab'
import { SettingsTab } from './tabs/SettingsTab'
import { BrandingTab } from './tabs/BrandingTab'

type TabKey = 'projects' | 'garments' | 'book' | 'settings' | 'branding'

const TABS: Array<{ key: TabKey; label: string }> = [
  { key: 'projects', label: 'Progetti' },
  { key: 'garments', label: 'Capi' },
  { key: 'book', label: 'Libro' },
  { key: 'settings', label: 'Impostazioni' },
  { key: 'branding', label: 'Brand' },
]

export function AppShell() {
  const { lock } = useAuth()
  const [tab, setTab] = useState<TabKey>('projects')
  const [pendingNewProjectGarmentId, setPendingNewProjectGarmentId] = useState<string | null>(null)
  const branding = getBranding()
  const studioName = branding.name || 'RD Studio'

  function startNewProjectFromGarment(garmentId: string) {
    setPendingNewProjectGarmentId(garmentId)
    setTab('projects')
  }

  return (
    <div className="app-shell">
      <header>
        <div className="brand-row">
          {branding.logoBase64 ? (
            <img src={branding.logoBase64} alt="" className="brand-logo-small" />
          ) : null}
          <h2>{studioName}</h2>
        </div>
        <button onClick={lock} title="Blocca la sessione: serve la password per rientrare">
          Esci
        </button>
      </header>
      <nav className="tabs">
        {TABS.map(t => (
          <button
            key={t.key}
            type="button"
            className={tab === t.key ? 'tab active' : 'tab'}
            onClick={() => setTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </nav>
      <main>
        {tab === 'projects' && (
          <ProjectsTab
            pendingNewGarmentId={pendingNewProjectGarmentId}
            onPendingConsumed={() => setPendingNewProjectGarmentId(null)}
          />
        )}
        {tab === 'garments' && (
          <GarmentsTab onCreateProjectFromGarment={startNewProjectFromGarment} />
        )}
        {tab === 'book' && <BookTab />}
        {tab === 'settings' && <SettingsTab />}
        {tab === 'branding' && <BrandingTab />}
      </main>
    </div>
  )
}
